import React from 'react'
import { PageHeader, FlexContainer, Tile, TextBase, Icon, Button } from '@reapit/elements'

type noteToUserProps = {
  notes?: string
  resumeId?: string
  onCancelResume?: any
  onAbandon?: any
}

const ShowNotesToUser: React.FC<noteToUserProps> = ({ notes, resumeId, onCancelResume, onAbandon }) => {
  const handleCopy = () => {
    if (notes) {
      navigator.clipboard.writeText(notes)
      alert('Notes copied to clipboard!')
    }
  }

  return (
    <>
      <PageHeader
        avatar={{
          src: 'complete.png',
          type: 'image',
        }}
        hasMaxWidth
        pageTitle={{
          children: 'Call Complete',
          hasBoldText: true,
        }}
        pageSubtitle={{
          children: 'Here are your notes',
        }}
      />
      <FlexContainer hasMaxWidth isFlexColumn>
        <Tile className="el-mb6">
          <p>
            <TextBase intent="danger">
              We were unable to locate this contact in Reapit... Please copy and paste this note manually.
            </TextBase>
          </p>
        </Tile>
        <Tile style={{ fontSize: '16px', position: 'relative' }}>
          <p className="el-mb3" style={{ fontWeight: 'bold' }}>
            Call Notes:
          </p>
          <p style={{ marginRight: '30px' }}>{notes}</p>
          <span
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              cursor: 'pointer',
            }}
          >
            <Icon icon="exportIcon" onClick={handleCopy} title="Copy notes" />
          </span>
        </Tile>

        <p className="el-mt5">
          <Button type="button" intent="primary" onClick={onAbandon}>
            Mark Call as Complete
          </Button>
          {resumeId && (
            <Button className="el-ml3" intent="danger" type="button" onClick={onCancelResume}>
              Cancel Resume
            </Button>
          )}
        </p>
      </FlexContainer>
    </>
  )
}

export default ShowNotesToUser
